import * as React from 'react';
import * as Server from "./Server"
import Select from '@mui/material/Select';
import NativeSelect from '@mui/material/NativeSelect';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import {label} from './Dictionary.js';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }));


const TimesOfDay = [
    <MenuItem value={0}>12:00 AM</MenuItem>,
    <MenuItem value={1}>1:00 AM</MenuItem>,
    <MenuItem value={2}>2:00 AM</MenuItem>,
    <MenuItem value={3}>3:00 AM</MenuItem>,
    <MenuItem value={4}>4:00 AM</MenuItem>,
    <MenuItem value={5}>5:00 AM</MenuItem>,
    <MenuItem value={6}>6:00 AM</MenuItem>,
    <MenuItem value={7}>7:00 AM</MenuItem>,
    <MenuItem value={8}>8:00 AM</MenuItem>,
    <MenuItem value={9}>9:00 AM</MenuItem>,
    <MenuItem value={10}>10:00 AM</MenuItem>,
    <MenuItem value={11}>11:00 AM</MenuItem>,
    <MenuItem value={12}>12:00 PM</MenuItem>,
    <MenuItem value={13}>1:00 PM</MenuItem>,
    <MenuItem value={14}>2:00 PM</MenuItem>,
    <MenuItem value={15}>3:00 PM</MenuItem>,
    <MenuItem value={16}>4:00 PM</MenuItem>,
    <MenuItem value={17}>5:00 PM</MenuItem>,
    <MenuItem value={18}>6:00 PM</MenuItem>,
    <MenuItem value={19}>7:00 PM</MenuItem>,
    <MenuItem value={20}>8:00 PM</MenuItem>,
    <MenuItem value={21}>9:00 PM</MenuItem>,
    <MenuItem value={22}>10:00 PM</MenuItem>,
    <MenuItem value={23}>11:00 PM</MenuItem>
];

const licensesStyle = {
    position: 'fixed',
    bottom: 100,
    right: 30,
    zIndex: 1,
    fontSize: "small"
  };

function Admin({set_battery_level_fn}) 
{
 
    const [ConfigData, setConfigData] = React.useState(null);
    const [IsSaved, setIsSaved] = React.useState(false);
    const [ShowToolTip, showToolTip] = React.useState(false);
    const searchParams = new URLSearchParams(document.location.search);
    const [isEvalDemo, setEvalDemo] = React.useState(false);
    const noSaveOnLoad = React.useRef(true);

    const handleTooltipClose = () => {
        showToolTip(false);
      };
    
      const handleTooltipOpen = () => {
        showToolTip(true);
    };

    function updateDeviceInfo()
    {
        Server.GetDeviceDetails(searchParams.get("device_id"))
        .then((res) => {
            set_battery_level_fn(res.data.battery_level, res.data.status)
            setEvalDemo(res.data.is_demo)

            let configdata = {}

            configdata.next_check_time = Server.TimeFormat24To12(res.data.next_scheduled_check_time_24_hrs);
            configdata.timezone = res.data.config.timezone;
            configdata.orientation = res.data.config.orientation;
            configdata.image_credits = res.data.image_credits;
            configdata.active_playlist = res.data.config.active_playlist;

            let update_interval_mins = Server.GetUpdateIntervalMinutes(res.data.config.update_times_24_hrs)
            switch(update_interval_mins) {
            case 60*24:
                configdata.interval = 0
                break;
            case 60*12:
                configdata.interval = 1
                break;
            case 60*6:
                configdata.interval = 2
                break;
            default:
                configdata.interval = 3
                configdata.custom_schedule_from = parseInt(res.data.config.update_times_24_hrs[0].split(":")[0])
                configdata.custom_schedule_to = parseInt(res.data.config.update_times_24_hrs[res.data.config.update_times_24_hrs.length-1].split(":")[0])
        
                switch(update_interval_mins) {
                case 1:
                    configdata.custom_schedule_interval = 0;
                    break;
                case 2:
                    configdata.custom_schedule_interval = 1;
                    break;
                case 5:
                    configdata.custom_schedule_interval = 2;
                    break;
                case 10:
                    configdata.custom_schedule_interval = 3;
                    break;
                case 15:
                    configdata.custom_schedule_interval = 4;
                    break;
                case 30:
                    configdata.custom_schedule_interval = 5;
                    break;
                case 60:
                    configdata.custom_schedule_interval = 6;
                    break;
                case 120:
                    configdata.custom_schedule_interval = 7;
                   break;
                default:
                    configdata.custom_schedule_interval = 8;
                   break;
                }
            }

            setConfigData(configdata)
            
        })
        .catch((err) => {});        
    }    

    React.useEffect(() => {
        updateDeviceInfo();
    }, []); 

    React.useEffect(() => {
        if (ConfigData!=null) {
            if (!noSaveOnLoad.current)
                saveConfig();
            noSaveOnLoad.current = false;
        }
    }, [ConfigData]);  

    function saveConfig() 
    {
         let config = {}
         config.timezone = ConfigData.timezone;
         config.orientation = ConfigData.orientation;
         config.active_playlist = ConfigData.active_playlist;

        if (ConfigData.interval==0)
            config.update_times_24_hrs = ["3:00"];
        else if (ConfigData.interval==1)
            config.update_times_24_hrs = ["3:00", "15:00"];
        else if (ConfigData.interval==2)
            config.update_times_24_hrs = ["3:00", "10:00", "16:00", "22:00"];
        else {
            config.update_times_24_hrs = [];
            let hours = 0;
            if (ConfigData.custom_schedule_from > ConfigData.custom_schedule_to)
                hours = (24 - ConfigData.custom_schedule_from) + ConfigData.custom_schedule_to;
            else
                hours = ConfigData.custom_schedule_to - ConfigData.custom_schedule_from;
            let updates = 0;
            switch(ConfigData.custom_schedule_interval) {
                case 0: // 1 min
                    updates = hours * 60;
                break;
                case 1: // 2 min
                    updates = hours * 30;
                break;
                case 2: // 5 min
                    updates = hours * 12;
                break;
                case 3: // 10 min
                    updates = hours * 6;
                break;
                case 4: // 15 min
                    updates = hours * 4;
                break;
                case 5: // 30 min
                    updates = hours * 2;
                break;
                case 6: // 1 hour
                    updates = hours;
                break;
                case 7: // 2 hours
                    updates = hours / 2;
                break;
                case 8: // 4 hours
                    updates = hours / 4;
                break;

            }
            updates += 1;
            let current_hour = ConfigData.custom_schedule_from;
            let current_min = 0;
            for (let i=0; i<updates; i++) {
                config.update_times_24_hrs.push(current_hour.toString() + ":" + current_min.toString().padStart(2,"0"));

                switch(ConfigData.custom_schedule_interval) {
                    case 0: // 1 min
                        current_min += 1;
                    break;
                    case 1: // 2 min
                        current_min += 2;
                    break;
                    case 2: // 5 min
                        current_min += 5;
                    break;
                    case 3: // 10 min
                        current_min += 10;
                    break;
                    case 4: // 15 min
                        current_min += 15;
                    break;
                    case 5: // 30 min
                        current_min += 30;
                    break;
                    case 6: // 1 hour
                        current_hour += 1;
                    break;
                    case 7: // 2 hours
                        current_hour += 2;
                    break;
                    case 8: // 4 hours
                        current_hour += 4;
                    break;

                }

                if (current_min == 60) {
                    current_hour += 1;
                    current_min = 0
                }
                if (current_hour==24)
                    current_hour = 0;

            }

        }

         Server.SetDeviceConfig(searchParams.get("device_id"), config)
         setIsSaved(true);
         console.log(config)
    }

    if (!ConfigData)
        return (<div></div>)
    else {

        const handleTimezoneChange = (event) => {
            setConfigData({...ConfigData, timezone: event.target.value});
        };
    
        const handlePlaylistChange = (event) => {
            setConfigData({...ConfigData, active_playlist: event.target.value});
        };

        const handleIntervalChange = (event) => {
            let new_config_data = {...ConfigData, interval:event.target.value}
            if (event.target.value == 3) {
                new_config_data.custom_schedule_from = 18;
                new_config_data.custom_schedule_to = 22;
                new_config_data.custom_schedule_interval = 5;
            }
            setConfigData(new_config_data);
        };
    
        const handleCustomFromChange = (event) => {
            setConfigData({...ConfigData, custom_schedule_from:event.target.value});
        };

        const handleCustomToChange = (event) => {
            setConfigData({...ConfigData, custom_schedule_to:event.target.value});
        };

        const handleCustomIntervalChange = (event) => {
            setConfigData({...ConfigData, custom_schedule_interval:event.target.value});
        };

        const handleOrientationChange = (event) => {
            setConfigData({...ConfigData, orientation:event.target.value});
        };
    
        var aryIanaTimeZones = Intl.supportedValuesOf('timeZone');
        let date = new Date;
        let listTimezones = [];
        aryIanaTimeZones.forEach((timeZone) =>
        {
        let timeZoneFormatted = timeZone.replaceAll("_", " ");
        if (timeZone.includes("/") && !timeZone.startsWith("Etc/"))
            listTimezones.push(<MenuItem value={timeZone} >{timeZoneFormatted}</MenuItem>);
        });      
    
        return (
            <>
            <Stack spacing={3}>
            <FormControl fullWidth>
            <InputLabel id="orientation_select_label">{label("ID_FrameOrientation")}</InputLabel>
            <Select
              labelId="orientation_select_label"
              id="orientation_select"
              value={ConfigData.orientation}
              label={label("ID_FrameOrientation")}
              onChange={handleOrientationChange}
            >
            <MenuItem value={"portrait"} >{label("ID_Portrait")}</MenuItem>           
            <MenuItem value={"landscape"} >{label("ID_Landscape")}</MenuItem>           
            </Select>
            </FormControl> 
            <FormControl fullWidth>
            <InputLabel id="timezone_select_label">{label("ID_TimeZone")}</InputLabel>
            <Select
              labelId="timezone_select_label"
              id="timezone_select"
              value={ConfigData.timezone}
              label={label("ID_TimeZone")}
              onChange={handleTimezoneChange}
            >
                {listTimezones}
            </Select>
            </FormControl>  
            <FormControl fullWidth>
            <InputLabel id="update_select_label">{label("ID_AdvanceThroughPlaylist")}</InputLabel>
            <Select
              labelId="update_select_label"
              id="update_select"
              value={ConfigData.interval}
              label={label("ID_AdvanceThroughPlaylist")}
              onChange={handleIntervalChange}
            >
            <MenuItem value={0} >{label("ID_OnceADay")}</MenuItem>           
            <MenuItem value={1} >{label("ID_2TimesADay")}</MenuItem>           
            <MenuItem value={2} >{label("ID_4TimesADay")}</MenuItem>           
            <MenuItem value={3} >{label("ID_CustomSchedule")}</MenuItem>           
            </Select>
            </FormControl> 
 
            {ConfigData.interval==3 ? (
            <div>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
            <InputLabel id="from_select_label">{label("ID_From")}</InputLabel>
            <Select
              labelId="from_select_label"
              id="from_select"
              value={ConfigData.custom_schedule_from}
              label={label("ID_From")}
              onChange={handleCustomFromChange}
            >
            {TimesOfDay}
            </Select>
            </FormControl> 
            <FormControl sx={{ m: 1, minWidth: 120 }}>
            <InputLabel id="to_select_label">{label("ID_To")}</InputLabel>
            <Select
              labelId="to_select_label"
              id="to_select"
              value={ConfigData.custom_schedule_to}
              label={label("ID_To")}
              onChange={handleCustomToChange}
            >
            {TimesOfDay}
            </Select>
            </FormControl> 
            <FormControl sx={{ m: 1, minWidth: 120 }}>
            <InputLabel id="interval_select_label">{label("ID_Every")}</InputLabel>
            <Select
              labelId="interval_select_label"
              id="interval_select"
              value={ConfigData.custom_schedule_interval}
              label={label("ID_Every")}
              onChange={handleCustomIntervalChange}
            >
            <MenuItem value={0} >{"1 " + label("ID_Min")}</MenuItem>           
            <MenuItem value={1} >{"2 " + label("ID_Mins")}</MenuItem>
            <MenuItem value={2} >{"5 " + label("ID_Mins")}</MenuItem>
            <MenuItem value={3} >{"10 " + label("ID_Mins")}</MenuItem>           
            <MenuItem value={4} >{"15 " + label("ID_Mins")}</MenuItem>           
            <MenuItem value={5} >{"30 " + label("ID_Mins")}</MenuItem>
            <MenuItem value={6} >{label("ID_Hour")}</MenuItem>
            <MenuItem value={7} >{"2 " + label("ID_Hours")}</MenuItem>           
            <MenuItem value={8} >{"4 " + label("ID_Hours")}</MenuItem>           
            </Select>
            </FormControl> 
            </div>
            ) : (
                <></>
            )}
            <div sx={{ minWidth: 220, display:'flex', alignItems:'center', justifyContent:'center'}}>
                <FormControl sx={{minWidth: `calc(100% - 35px)`}}>
                    <InputLabel id="playlist_select_label">{label("ID_Playlist")}</InputLabel>
                    <Select
                    labelId="playlist_select_label"
                    id="playlist_select"
                    value={ConfigData.active_playlist}
                    label={label("ID_Playlist")}
                    onChange={handlePlaylistChange}
                    >
                    <MenuItem value={0} >{label("ID_Primary")}</MenuItem>           
                    <MenuItem value={1} >{label("ID_Secondary")}</MenuItem>           
                    </Select>
                </FormControl>  
                <ClickAwayListener onClickAway={handleTooltipClose}>
                <Tooltip 
                    onClose={handleTooltipClose}
                    open={ShowToolTip}
                    disableFocusListener 
                    disableHoverListener
                    disableTouchListener
                    slotProps={{
                    popper: {
                        disablePortal: true,
                    },
                    }}
                    title={label("ID_SecondaryPlaylistMessage")}>
                <InfoOutlinedIcon onClick={handleTooltipOpen} sx={{marginLeft:1, marginTop:2}}/>
                </Tooltip>   
                </ClickAwayListener>
            </div>     
            <FormControl fullWidth>
                {label("ID_AIImageCreditsRemainingMessage").replace("%1", ConfigData.image_credits)}
            </FormControl>
            {IsSaved ? (
            <FormControl fullWidth>
                <span style={{fontSize:"small", color:"rgba(255,94,73)"}}>{label("ID_WakeToApplyMessage").replace("%1", ConfigData.next_check_time)}</span>
            </FormControl>
            ) : (
                <></>
            )}
            <br/>
            <a style={licensesStyle} href="/licenses.txt">{label("ID_OpenSourceLicenses")}</a>
            </Stack>       
     
            </>
        );       
    }

};

export default Admin;

